export function getTenant() {
  const host =
    window.RUNTIME_HOST || window.location.host;

  if (host.startsWith("pa.") || host.includes(".pa.")) {
    return "pa";
  }

  return "public";
}
